import type { EditableThemeTokenName } from '@/shared/theme/theme-config'

export const tokenUsageExamples: Record<
  EditableThemeTokenName,
  { summary: string; examples: Array<string> }
> = {
  background: {
    summary:
      'Page canvas, table and header backgrounds, and empty-state panels.',
    examples: [
      'App page canvas',
      'Table & header backgrounds',
      'Empty-state panels',
    ],
  },
  foreground: {
    summary: 'Primary text on pages, section headings, and table cell content.',
    examples: ['Primary page text', 'Section headings', 'Table cell text'],
  },
  card: {
    summary:
      'Card surfaces across dashboards, collections, dialogs, and sheets.',
    examples: [
      'Dashboard cards',
      'Collection panels',
      'Dialog & sheet surfaces',
    ],
  },
  'card-foreground': {
    summary: 'Text and metadata displayed inside card components.',
    examples: ['Text inside cards', 'Card titles', 'Card metadata'],
  },
  primary: {
    summary:
      'Primary action buttons, active navigation items, and key highlights.',
    examples: [
      'Main action buttons',
      'Active nav items',
      'Key icons & highlights',
    ],
  },
  'primary-foreground': {
    summary:
      'Content shown on primary-colored surfaces like buttons and selected labels.',
    examples: [
      'Text/icons on primary buttons',
      'Active sidebar labels',
      'Selected color blocks',
    ],
  },
  accent: {
    summary:
      'Subtle hover and highlight states for rows and secondary controls.',
    examples: [
      'Row hover states',
      'Subtle highlighted controls',
      'Secondary hover backgrounds',
    ],
  },
  'accent-foreground': {
    summary:
      'Text and icons that appear on accent hover backgrounds or focused items.',
    examples: [
      'Text on accent hover backgrounds',
      'Focused dropdown rows',
      'Highlighted ghost buttons',
    ],
  },
  border: {
    summary: 'Separator lines for cards, tables, inputs, and panels.',
    examples: ['Card outlines', 'Table dividers', 'Input & panel borders'],
  },
  ring: {
    summary:
      'Focus indicators for keyboard navigation and active form controls.',
    examples: [
      'Keyboard focus rings',
      'Active input outlines',
      'Color picker focus states',
    ],
  },
  sidebar: {
    summary: 'Background of the main sidebar and mobile navigation panels.',
    examples: ['Left navigation background', 'Mobile side panel background'],
  },
  'sidebar-foreground': {
    summary:
      'Default text in sidebar links, section labels, and workspace switcher.',
    examples: [
      'Default sidebar links',
      'Sidebar section labels',
      'Workspace switcher text',
    ],
  },
  'sidebar-primary': {
    summary:
      'Background for the active sidebar item and selected sidebar action.',
    examples: ['Active sidebar item background', 'Selected sidebar action'],
  },
  'sidebar-primary-foreground': {
    summary: 'Text and icons shown on the active sidebar item background.',
    examples: ['Text/icons on active sidebar items'],
  },
  'sidebar-accent': {
    summary:
      'Background that appears on hovered sidebar links and utility buttons.',
    examples: [
      'Sidebar link hover background',
      'Sidebar utility button hover background',
    ],
  },
  'sidebar-accent-foreground': {
    summary: 'Text and icons that appear on hovered sidebar items.',
    examples: ['Text/icons on hovered sidebar items'],
  },
}
